import { deleteGrade, deleteParapar, deleteSurfacado } from "../../api"
import config from "../../environments/generated.config"
import { useBasket, useResponsive, getHasBasketContent } from "../../providers"

import Layout from "./Layout"

export default function Resume({ order }) {
  const { isMobile } = useResponsive()
  const { home } = config.urls

  const { basketReload } = useBasket()

  const urls = {
    type: `${home}${config.urls[`order_${order.type}`]}`,
  }

  const deletes = {
    parapar: deleteParapar,
    grade: deleteGrade,
    surfacado: deleteSurfacado,
  }

  const handleDelete = async () => {
    const deleteType = deletes[order.type]

    await deleteType()

    basketReload()

    await getHasBasketContent()
  }

  const isntSurfacado = order.type !== "surfacado"

  const layoutProps = {
    urls,
    order,
    isMobile,
    handleDelete,
    isntSurfacado,
  }

  return <Layout {...layoutProps} />
}
